import { render, staticRenderFns } from "./tradeLineComponent.vue?vue&type=template&id=a2960882&scoped=true&"
import script from "./tradeLineComponent.vue?vue&type=script&lang=js&"
export * from "./tradeLineComponent.vue?vue&type=script&lang=js&"
import style0 from "./tradeLineComponent.vue?vue&type=style&index=0&id=a2960882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2960882",
  null
  
)

export default component.exports